module.exports = __webpack_public_path__ + "assets/img/free_11.8863c8ab.png";